import { useEffect } from 'react'
import { ALL_TOURS, shouldShowTour, TOUR_DOM_READY_DELAY_MS } from '../config/tourSteps'

/**
 * Inicia automáticamente el tour de la página si el usuario no lo completó
 * (localStorage distinto de la versión actual). Emite `tour:start` (no forzado).
 *
 * @param {string} tourId - Clave en ALL_TOURS (ej. 'dashboard-page')
 * @param {{ enabled?: boolean, syncKey?: number }} [options] - `syncKey` opcional para re-evaluar cuando cambia el estado (p. ej. novedades / snooze)
 */
export function usePageTour(tourId, options = {}) {
  const { enabled = true, syncKey = 0 } = options

  useEffect(() => {
    if (!enabled) return

    const tour = ALL_TOURS[tourId]
    if (!tour) {
      console.warn('[usePageTour] Tour desconocido:', tourId)
      return
    }
    if (!shouldShowTour(tour)) return

    const t = window.setTimeout(() => {
      window.dispatchEvent(new CustomEvent('tour:start', { detail: { tourId } }))
    }, TOUR_DOM_READY_DELAY_MS)

    return () => window.clearTimeout(t)
  }, [tourId, enabled, syncKey])
}

/**
 * Fuerza el inicio de un tour (p. ej. desde HelpButton).
 */
export const forceTour = (tourId) => {
  window.dispatchEvent(new CustomEvent('tour:start-forced', { detail: { tourId } }))
}
